import React from 'react'
import appSettings from '../../helpers/settings';

const Header = props => {
  return (
    <div>
      <header className="header">
        <div className="navbar navbar-default navbar-fixed-top">
          <div className="container">
            <div className="row">
              <div className="navbar-header page-scroll">
                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#myNavbar">
                  <span className="sr-only">Navegación</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
                <a className="navbar-brand page-scroll" href="/">
                  <h4 style={ { color: 'white', marginBottom: 0 } }>{appSettings.title}</h4>
                </a>
              </div>

              <div className="navbar-collapse collapse" id="myNavbar">
                <ul className="nav navbar-nav navbar-right">
                  <li className="active"><a className="page-scroll" href="#slider">Inicio</a></li>
                  <li><a className="page-scroll" href="#about">Acerca de</a></li>
                  <li><a className="page-scroll" href="#download">Descargar</a></li>
                  {/*<li><a className="page-scroll" href="#howitworks">Cómo funciona</a></li>
                  <li><a className="page-scroll" href="#features">Características</a></li>
                  <li><a className="page-scroll" href="#faqs">Preguntas</a></li>
                  <li><a className="page-scroll" href="#screenshots">Capturas</a></li>*/}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  )
}


export default Header;